import React from 'react';
import { ScrollView } from 'tamagui';

import { CobuContainer, CobuStack, CobuText } from '@cobu/ui';
import type { ReferralOffer } from '@cobu/types/perk';
import { Strings } from '../../constants/Strings';
import { referralRewardText } from '../../utils/referralReward';

interface OfferDetailsProps {
  referralOffer: ReferralOffer;
}

export const OfferDetails: React.FC<OfferDetailsProps> = ({ referralOffer }) => {
  const reward = referralRewardText(referralOffer);
  const rules = referralOffer.rulesAndEligibility?.trim();

  return (
    <CobuContainer f={1} bg="$white">
      <ScrollView showsVerticalScrollIndicator={false}>
        <CobuStack gap="$4" pb="$4">
          <CobuStack px="$4" py="$2" bbw={1} bbc="$backgroundMuted">
            <CobuText variant="heading" fontSize="$6" fontWeight="bold" color="$cobuDarkBlue">
              {referralOffer.title}
            </CobuText>
          </CobuStack>

          {reward && (
            <CobuText variant="body" fontSize="$5" fontWeight="bold" color="$cobuDarkBlue" ussel="text" px="$4">
              {reward}
            </CobuText>
          )}

          {referralOffer.description && (
            <CobuText variant="body" fontSize="$4" color="$color" ussel="text" px="$4">
              {referralOffer.description}
            </CobuText>
          )}

          {rules && (
            <CobuStack px="$4" gap="$2">
              <CobuText variant="heading" fontSize="$4" fontWeight="bold" color="$cobuDarkBlue">
                {Strings.get().referral.offer.termsHeading}
              </CobuText>
              <CobuText variant="body" fontSize="$3" color="$colorSecondary" ussel="text">
                {rules}
              </CobuText>
            </CobuStack>
          )}
        </CobuStack>
      </ScrollView>
    </CobuContainer>
  );
};
